import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../AxiosInstance";
import useAuthenticate from "./useAuthenticate";

const usePendingCart = () => {
  const authenticated = useAuthenticate();

  const {
    data: pendingCart,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["pendingCart", { authenticated }],
    queryFn: () => axiosInstance.get("/cart/pending/"),
    enabled: authenticated,
  });

  return { data: pendingCart?.data || [], isLoading, error };
};

export default usePendingCart;
